<script lang="ts">
import { useCtaComponent } from '@monogrid/vue-boost/core'
import { defineComponent, PropType } from 'vue'

import IconComponent, { icons } from '@/components/atoms/IconComponent.vue'

export default defineComponent({
  name: 'CtaIcon',
  components: {
    IconComponent
  },
  props: {
    circle: { type: Boolean, default: false },
    icon: { type: String as PropType<keyof typeof icons>, required: true }
  },
  setup (props, context) {
    const { bindings, component } = useCtaComponent(context)

    return {
      bindings,
      component
    }
  }
})
</script>

<template>
  <component
    :is="component"
    v-bind="bindings"
    class="cta-icon inline-flex flex-nowrap gap-2 items-center label1 whitespace-nowrap"
  >
    <span v-if="$slots.labelStart"><slot name="labelStart" /></span>
    <span class="wrapper-icon inline-flex items-center justify-center w-10 h-10" :class="{circle}">
      <IconComponent class="w-3 h-3" :icon="icon" />
    </span>
    <span v-if="$slots.labelEnd"><slot name="labelEnd" /></span>
  </component>
</template>
<style lang="scss" scoped>
.cta-icon {
  transition: opacity var(--transition-duration);

  &[disabled] {
    opacity: 0.5;
    pointer-events: none;
  }

  @include hover {
    .wrapper-icon {
      transition: background-color var(--transition-duration), border-color var(--transition-duration), color var(--transition-duration);
    }

    span:not(.wrapper-icon) {
      transition: transform var(--transition-duration);
    }

    &:hover {
      .wrapper-icon {
        border-color: color('white');
        background-color: color('white');
        color: color('black');
      }

      span:first-child:not(.wrapper-icon) {
        transform: translateX(-4px);
      }

      span:last-child:not(.wrapper-icon) {
        transform: translateX(4px);
      }
    }
  }
}

.wrapper-icon {
  border: 1px solid currentColor;
  border-radius: rem(4px);

  &.circle {
    border-radius: 50%;
  }
}
</style>
